/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".time-picker[_ngcontent-%COMP%]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.time-picker[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{touch-action:manipulation}.time-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer;display:block;width:2rem;text-align:center;border:1px solid rgba(0,0,0,.5);border-radius:3px;outline:0;font-size:1.2rem;padding:.2rem}.time-picker[_ngcontent-%COMP%]   .dot[_ngcontent-%COMP%]{width:4px;height:4px;background-color:#000;border-radius:50%}"];
export { styles as styles };
